import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import LayoutTwoColumnsIcon from '@atlaskit/icon/core/layout-two-columns';
var LayoutBlockMenuItem = function LayoutBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isLayoutSelected = useMemo(function () {
    if (!selection) {
      return false;
    }
    if (selection instanceof NodeSelection) {
      return selection.node.type.name === 'layoutSection';
    }
    return false;
  }, [selection]);
  var handleClick = function handleClick() {
    var _api$blockMenu;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode('layoutSection'));
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isLayoutSelected,
    elemBefore: /*#__PURE__*/React.createElement(LayoutTwoColumnsIcon, {
      label: ""
    })
  }, formatMessage(blockMenuMessages.layout));
};
export var createLayoutBlockMenuItem = function createLayoutBlockMenuItem(api) {
  return function () {
    return /*#__PURE__*/React.createElement(LayoutBlockMenuItem, {
      api: api
    });
  };
};